import { defineComponent } from "vue";

/**
 * 渲染 `Navigation` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const Navigation = defineComponent({
	name: "Navigation",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
				<path d="M959.216 118.828c-0.045-0.325-0.091-0.65-0.142-0.975a66.716 66.716 0 0 0-0.269-1.559 61.902 61.902 0 0 0-0.403-2.052l-0.094-0.417a63.593 63.593 0 0 0-2.326-8.049c-12.039-33.077-48.952-50.29-82.029-38.251L106.889 346.712c-23.048 8.389-38.378 28.857-41.492 51.686-6.057 24.444 2.67 51.341 24.135 67.121l238.847 175.584L864 160 383.998 681.99l0.013 0.01H384v178.594c-1.066 9.375 1.968 19.138 9.118 26.289 12.445 12.445 32.81 12.445 45.255 0l95.047-95.047L745.185 947.51a63.388 63.388 0 0 0 23.475 10.747 63.49 63.49 0 0 0 14.671 3.811c34.884 4.706 67.276-19.986 71.981-54.87l103.985-770.867a63.44 63.44 0 0 0-0.081-17.503z" />
			</svg>
		);
	},
});

export default Navigation;
